import React, { Component } from 'react';
import './Game.css';

import { connect } from 'react-redux';

import classnames from 'classnames';

import Macro from './Macro/Macro';

class Game extends Component {
  render() {
    // If game has started
    if (this.props.board) {
      return (
        <div className={classnames({ Game: true, [this.props.player]: true })}>
          <Macro onMove={this.props.onMove} />
        </div>
      );
    } else {
      return (
        <div className="Game">
          <h1>Waiting for game to start...</h1>
        </div>
      );
    }
  }
}

const mapStateToProps = state => {
  return {
    board: state.board,
    player: state.player
  }
}

export default connect(mapStateToProps)(Game);



// WEBPACK FOOTER //
// ./src/Game/Game.js